import { render } from "./gauge.vue?vue&type=template&id=5d788610&scoped=true&ts=true"
import script from "./gauge.vue?vue&type=script&lang=ts"
export * from "./gauge.vue?vue&type=script&lang=ts"

import "./gauge.vue?vue&type=style&index=0&id=5d788610&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d788610"]])

export default __exports__